import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import SMS from '../../models/SMS';
import { IContact } from '@leedpulse-monorepo/interfaces';

async function toggleSMSReadStatus(
  contact: IContact,
  message: SMS,
  auth: Authentication
): Promise<void> {
  try {
    await HttpClient.put(
      `/sms/${message.id}/${
        message.readedBackoffice ? 'unread' : 'read'
      }/backoffice`,
      {},
      auth.token,
      {
        'x-api-key': contact.id_api_key,
      }
    );
    return;
  } catch (e) {
    console.log('error: ', e);
    throw new ToggleSMSReadStatusFailure();
  }
}

export class ToggleSMSReadStatusFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default toggleSMSReadStatus;
